import ContentBoxFigure from './ContentBoxFigure';

export default ContentBoxFigure;
